import { YStack } from "tamagui";

import { useUpdateVitals } from "@/api/generated";
import { Heading, Paragraph } from "@/components";
import HeightWeightInput from "@/conversation/HeightWeightInput";

export const VitalsScreen = ({ onContinue }: { onContinue: () => void }) => {
  const { mutate: updateVitals } = useUpdateVitals();

  return (
    <YStack gap="$200" flex={1} paddingHorizontal="$200" paddingBottom="$200">
      <YStack gap="$100">
        <Heading size="$xl">{"What's your height and weight?"}</Heading>
        <Paragraph color="$textSecondary" size="$s">
          This helps us provide accurate treatment recommendations.
        </Paragraph>
      </YStack>
      <HeightWeightInput
        onSubmit={({ heightIn, weightLb }) =>
          updateVitals(
            { data: { height_in: heightIn, weight_lb: weightLb } },
            { onSuccess: onContinue, onError: onContinue },
          )
        }
      />
    </YStack>
  );
};
